export function execLoop(loop, nb_loop) {
    apiFetch('/api/exec_loop/' + loop + '/' + nb_loop, {
      method: 'GET',
         timeout: 0,   // no timeout
    retry: 0      // no retry
  }).catch(() => {
    // optional: ignore errors completely
  })  
    
  }

  export async function robot(func, options = {}) {
  
    const result = await apiFetch('/api/robot/' + func, {
      method: 'GET',
      ...options
    })
    console.log(result)
    return result
  }
  
  
  export async function robot_post(func, data) {
  try {
    const result = await apiFetch('/api/robot/' + func, {
      method: 'POST',
      body: data
    })
    console.log(result)
    return result
  } catch (error) {
    console.error(error)
    return error
  }
}
  
  export async function robotExec(id, single, loop_p = 0, increments = {}) {
    const normalized = typeof increments === 'object' && increments !== null ? increments : { y: increments }
    const result = await apiFetch('/api/exec', {
      method: 'POST',
      body: {
        id,
        mode: single,
        loop: loop_p,
        increment_x: Number(normalized.x || 0),
        increment_y: Number(normalized.y || 0),
        increment_z: Number(normalized.z || 0),
        increment_a: Number(normalized.a || 0),
        increment_b: Number(normalized.b || 0),
        increment_g: Number(normalized.g || 0)
      }
    })
    console.log(result)
  }
  
